<template>
	<div class="is-clearfix is-relative" @mouseover="editing = true" @mouseleave="editing = false">
		<div :class="{ 'is-transparent': !active, 'is-invisible': readOnly }" class="is-overlay">
			<div class="select is-small is-fullwidth">
				<select
					:value="value"
					:disabled="readOnly"
					@focus="focused = true"
					@blur="focused = false"
					@change="$emit('input', $event.target.value)">
					<option
						v-for="option in options"
						:key="option[valueField]"
						:value="option[valueField]">
						{{ $t(option[resourceKeyField]) }}
					</option>
				</select>
			</div>
		</div>
		<div :class="{ 'is-invisible': active, 'is-pointerless': !readOnly }" class="is-clearfix">
			<div :class="{ 'has-text-info': !readOnly }" class="select-label is-pulled-right">
				<slot name="cover">
					{{ coverLabel }}
				</slot>
				<dp-svg v-if="!readOnly" class="is-info" svg="actionEdit" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DpSelect',
	props: {
		coverLabel: { type: String, default: null },
		value: { type: String, default: null },
		options: { type: Array, default: () => [] },
		valueField: { type: String, default: 'name' },
		readOnly: { type: Boolean, default: false },
		resourceKeyField: { type: String, default: 'resourceKey' },
	},
	data: () => ({ editing: false, focused: false }),
	computed: {
		active() { return !this.readOnly && (this.editing || this.focused); },
	},
};
</script>

<style scoped>
.select-label {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr auto;
	justify-items: end;
	white-space: nowrap;
}
.select-label .has-svg {
	width: 1.25em;
	height: 1.25em;
	margin-left: 0.25em;
	vertical-align: top;
}
</style>
